<template>
  <div id="app">
    <app-rate v-if="!isBkash"></app-rate>
    <app-bkashrate v-if="isBkash"></app-bkashrate>
  </div>
</template>

<script>

/* eslint-disable */
/* eslint-disable vue/no-unused-components */
import Rate from './views/Rate.vue'
import Bkashrate from './views/Bkashrate.vue'
export default {
  components: {
    appRate: Rate,
    appBkashrate: Bkashrate
  },
  computed: {
    isBkash() {
      console.log('bkash testing');
      console.log(this.$route.name);
      return this.$route.name.toLowerCase() === 'bkash';
    }
  }
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
